import { TABLE_CHART } from './TableChart.constants';
import TableChartEPA_Bar from './TableChartEPA_Bar';
import TableChartPlayPercBar from './TableChartPlayPercBar';

export const getTableChart = (chart, value) => {
  const { EPA, PLAY_PERCENTAGE, PLAY_PERCENTAGE_SMALL } = TABLE_CHART;
  switch (chart) {
    case EPA:
      // eslint-disable-next-line react/jsx-pascal-case
      return TableChartEPA_Bar({ value });
    case PLAY_PERCENTAGE:
      return TableChartPlayPercBar({
        value,
        cellHeight: 32,
        barHeight: 20,
        max: 50,
      });
    case PLAY_PERCENTAGE_SMALL:
      return TableChartPlayPercBar({
        value,
        cellHeight: 24,
        barHeight: 12,
        max: 50,
      });
    default:
      return null;
  }
};
